export const TASK_REGISTER_COLUMNS = ['title', 'status', 'priority', 'owner', 'module', 'progress', 'due', 'source', 'actions'];

export const TASK_MODULE_LABELS = {
  FR: {
    DOCUMENTS: 'Documents', RECETTES: 'Recettes', DEPENSES: 'Dépenses', FINANCE: 'Finance', FINANCES: 'Finances',
    SOCIAL: 'Social', IMMO: 'Immo', STOCKS: 'Stocks', ACTIFS: 'Actifs', TACHES: 'Tâches', RH: 'RH', GED: 'GED',
    CRM: 'CRM', PRODUCTION: 'Production', FX: 'Convertisseur FX', ADMINISTRATION: 'Administration'
  },
  DE: {
    DOCUMENTS: 'Dokumente', RECETTES: 'Einnahmen', DEPENSES: 'Ausgaben', FINANCE: 'Finanzen', FINANCES: 'Finanzen',
    SOCIAL: 'Soziales', IMMO: 'Immobilien', STOCKS: 'Bestände', ACTIFS: 'Aktiva', TACHES: 'Aufgaben', RH: 'Personal',
    GED: 'Dokumentenverwaltung', CRM: 'CRM', PRODUCTION: 'Produktion', FX: 'FX-Konverter', ADMINISTRATION: 'Verwaltung'
  },
  EN: {
    DOCUMENTS: 'Documents', RECETTES: 'Income', DEPENSES: 'Expenses', FINANCE: 'Finance', FINANCES: 'Finance',
    SOCIAL: 'Social', IMMO: 'Real estate', STOCKS: 'Stock', ACTIFS: 'Assets', TACHES: 'Tasks', RH: 'HR',
    GED: 'Document management', CRM: 'CRM', PRODUCTION: 'Production', FX: 'FX converter', ADMINISTRATION: 'Administration'
  }
};
